<div class="container container-fluid">
    <div class="panel panel-danger mt-10">
        <div class="panel-heading">
            <h3 class="panel-title">Access Denied</h3>
        </div>
        <div class="panel-body">
            @if (error) {
                <h2>{{error.status}} - {{error.statusText}}</h2>
                <p>{{error.message}}</p>
                @if (error.response) {
                    <p>{{error.response}}</p>
                }
            }
            @else {
                <h2>403 - Forbidden</h2>
                <p>You do not have permission to access this page.</p>
            }
        </div>
    </div>
</div>
